import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PageLayout from '../../layouts/PageLayout';
import FeatureFlagSwitchboard from '../../components/FeatureFlagSwitchboard';

/**
 * #120646 (bản vẽ sếp duyệt ở #115005) — màn "Tính Năng Mới".
 *
 * Các công tắc bật/tắt tính năng mới trước đây nằm lẫn trong màn Cấu Hình Hệ Thống (hơn trăm dòng),
 * nay tách hẳn ra menu riêng trong nhóm "Quản lý hệ thống" để tìm là thấy ngay.
 *
 * Dùng LẠI đúng bảng công tắc đã có (`FeatureFlagSwitchboard`, việc #160017) — ghi qua đúng cửa cũ
 * của bảng cấu hình, KHÔNG đẻ cơ chế bật/tắt thứ hai.
 */
export default function FeatureFlagPage() {
  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mb-3">
            <h3 className="mb-1">Tính Năng Mới</h3>
            <p className="text-muted mb-0">
              Bật / tắt các tính năng mới cho toàn hệ thống. Một nút là xong, có hiệu lực ngay.
            </p>
          </div>
          <FeatureFlagSwitchboard
            tieuDe={null}
            hienCanhTrong
          />
          <p className="text-muted small">
            Tắt ở đây là tắt cho <b>mọi quán, mọi bàn</b> và có hiệu lực ngay lập tức. Danh sách này chỉ hiện công tắc
            mức <b>dùng chung</b> — công tắc riêng của một quán vẫn nằm ở màn của chính tính năng đó.
          </p>
        </Col>
      </Row>
    </PageLayout>
  );
}
